import { jsx as E } from "react/jsx-runtime";
import { useEffect as u } from "react";
import d from "../../../make-cancellable-promise/dist/esm/index.es.js";
import g from "../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
import x from "../../../warning/warning.es.js";
import P from "./StructTreeItem.es.js";
import R from "./shared/hooks/usePageContext.es.js";
import v from "./shared/hooks/useResolver.es.js";
import { cancelRunningTask as C } from "./shared/utils.es.js";
function D() {
  const n = R();
  g(n, "Unable to find Page context.");
  const { onGetStructTreeError: s, onGetStructTreeSuccess: i } = n, [m, e] = v(), { value: r, error: o } = m, { customTextRenderer: a, page: t } = n;
  function p() {
    r && i && i(r);
  }
  function T() {
    o && (x(!1, o.toString()), s && s(o));
  }
  return u(function() {
    e({ type: "RESET" });
  }, [e, t]), u(function() {
    if (a || !t)
      return;
    const f = d(t.getStructTree()), S = f;
    return f.promise.then((c) => {
      e({ type: "RESOLVE", value: c });
    }).catch((c) => {
      e({ type: "REJECT", error: c });
    }), () => C(S);
  }, [a, t, e]), u(() => {
    if (r !== void 0) {
      if (r === !1) {
        T();
        return;
      }
      p();
    }
  }, [r]), r ? E(P, { className: "react-pdf__Page__structTree structTree", node: r }) : null;
}
export {
  D as default
};
//# sourceMappingURL=StructTree.es.js.map
